import { render, staticRenderFns } from "./ContractList.vue?vue&type=template&id=64ba6988&scoped=true"
import script from "./ContractList.vue?vue&type=script&lang=js"
export * from "./ContractList.vue?vue&type=script&lang=js"
import style0 from "./ContractList.vue?vue&type=style&index=0&id=64ba6988&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba6988",
  null
  
)

export default component.exports